import React, { useEffect } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { useResolvedPath, useMatch } from 'react-router-dom';
import { toggleCollapsedNav, sidebarDataHover } from '../../redux/action/Theme';
import PageFooter from '../Footer/PageFooter';
import { useWindowWidth } from '@react-hook/window-size';
import Navbar from '../Navbar';

const CompactLayout = ({ children, navCollapsed, topNavCollapsed, toggleCollapsedNav, sidebarDataHover, dataHover, maximize }) => {

    const appRoutes = useMatch('/apps/');
    // const appRoutes = useResolvedPath('/INTENTIONAL-WRONG-NAME/').pathname;
    // const appRoutes = useResolvedPath('/apps/').pathname;
    const errro404Route = useMatch('/error-404');
    // const errro404Route = useResolvedPath('/error-404').pathname;
    const windowWidth = useWindowWidth();

    // console.log("IS THIS 404route: ", errro404Route)

    useEffect(() => {
        if (windowWidth > 1199) {
            toggleCollapsedNav(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowWidth])

    return (
        <div
            className={classNames("hk-wrapper", { "hk-pg-auth": errro404Route }, { "hk__email__backdrop": maximize })}
            data-layout="navbar"
            data-layout-style={navCollapsed ? "collapsed" : "default"}
            data-navbar-style={topNavCollapsed ? "collapsed" : ""}
            data-menu="light"
            data-footer="simple"
        >
            <Navbar />
            <div className={classNames("hk-pg-wrapper", { "pb-0": appRoutes })}>
                {children}
                {/* {!appRoutes && <PageFooter />} */}
                <PageFooter />
            </div>
        </div>
    )
}

const mapStateToProps = ({ theme, emailReducer }) => {
    const { navCollapsed, topNavCollapsed, dataHover } = theme;
    const { maximize } = emailReducer
    return { navCollapsed, topNavCollapsed, dataHover, maximize }
};

export default connect(mapStateToProps, { toggleCollapsedNav, sidebarDataHover })(CompactLayout)
